// Öppna externa länkar i nytt fönster
window.addEventListener('load', function() {
  document.querySelectorAll('a[href^="http"]').forEach(function(a) {
    if (!a.href.includes(window.location.hostname)) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    }
  });
});